import { getJSON, postJSON, deleteJSON } from "@/lib/api"
import { type KnowledgeItemType, type KnowledgeItem } from "@yomimono/types"

export type { KnowledgeItemType, KnowledgeItem }

export const getKnowledgeItems = ({
  type,
  search,
}: {
  type: KnowledgeItemType
  search: string
}) => {
  const params = new URLSearchParams({ type })
  const trimmedSearch = search.trim()

  if (trimmedSearch) {
    params.set("search", trimmedSearch)
  }

  return getJSON<KnowledgeItem[]>(`/v1/user/knowledge?${params.toString()}`)
}

export const addKnowledgeItem = (data: {
  type: KnowledgeItemType
  text: string
}) => postJSON<KnowledgeItem>("/v1/user/knowledge", data)

export const deleteKnowledgeItem = (id: string) =>
  deleteJSON(`/v1/user/knowledge/${id}`)
